<template>
  <Container>
    <h1>Composition des équipes</h1>
    <div class="row">
      <div v-for="team in teams" class="column" v-bind:key="team.id">
        <div class="team">          
          <div class="team-title" :style="'background-color: ' + team.color">Equipe {{team.name}}<a class="badge-button" v-on:click="deleteTeam(team.id)"><i class="material-icons">remove</i></a></div>
          <div class="team-content">
            <p v-for="player in team.players" v-bind:key="player.id" style="margin-bottom:10px;">
              {{player.firstname}} {{player.name}}
              <span class="badge">{{player.hat}}</span>
            </p>
          </div>
          <div class="team-action">
            <a href="#" v-on:click="updateTeam(team)">Modifier l'équipe</a>
          </div>
        </div>
      </div>
    </div>

    <label for="nbSimples">Nombre de simples</label>
    <input v-model="tournamentParams.nbSingles" name="nbSimples" id="nbSimples" type="text" class="input-large" />

    <label for="nbDoubles">Nombre de doubles</label>
    <input v-model="tournamentParams.nbDoubles" name="nbDoubles" id="nbDoubles" type="text" class="input-large"/>

    <div class="button-bar">
      <a class="button" v-on:click="initTournament()"><i class="material-icons">build</i>Initialiser les matchs</a>
      <a class="button" id="delete-button" v-on:click="clearTournament()"><i class="material-icons">delete</i>Supprimer le tournoi en cours</a>
    </div>
    <a class="round-button fixed-button" v-on:click="addTeam()"><i class="material-icons">add</i></a>
  </Container>
</template>

<script>
// @ is an alias to /src
import Match from "@/components/Match.vue";
import Container from "@/components/Container.vue";
import axios from "axios";

export default {
  name: "teams",
  components: {
    Container
  },
  data: function(){
    return {
      tournamentParams: {
        nbSingles: 0,
        nbDoubles: 0
      }
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams;
    }
  },
  methods: {
    updateTeam: function(team){
      this.$router.push('team/' + team.id);
    },
    initTournament: function(){
      axios.post("/tournament/init", this.tournamentParams)
        .then(response => {this.$snack.success('Tournoi initialisé');})
        .catch(error => {this.$snack.danger('Tournoi déjà initialisé');});
    },
    clearTournament: function(){
      axios.get("/tournament/clear")
        .then(response => {this.$snack.success('Tournoi supprimé');})
        .catch(error => {this.$snack.danger('Impossible de supprimer le tournoi');});
    },
    addTeam :function(){
      axios.get("/teams/new");
    },
    deleteTeam: function(id){
      axios.delete("/teams/" + id);
    }
  }
};
</script>

<style scoped>
.row{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.team{
  box-shadow: 0.1em 0.3em 0.4em #ddd;
  margin: 10px;
}
.team-title{
  width: 100%;
  text-align: center;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-weight: bold;
  color: #404040;
}
.team-content{
  padding-left: 0.3em;
  padding-right: 0.3em;
}
.badge{
  float: right;
  width: 2em;
  height: 1.5em;
  text-align: center;
  background-color: #404040;
  border-radius: 10px;
  color: whitesmoke;
}

.badge-button{
  float: right;
  width: 2em;
  height: 1.5em;
  text-align: center;
  background-color: #404040;
  border-radius: 10px;
  margin-right: 5px;
  cursor: pointer;
}

.badge-button i{
  color: whitesmoke;
}

.team-action{
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  text-align: center;
  border-top: 1px solid #e0e0e0;
}
.team a{
  color: #404040;
}
.button-bar{
  margin-left: 10px;
}
#delete-button{
  margin-left: 20px;
  background-color: rgb(201, 0, 0);
  color: whitesmoke;
}
</style>